import React, { useState, Fragment } from "react";
import { Field } from "formik";
import {
  FieldInput,
  FieldInputPercentage,
  FieldInputNumber,
  AddPlans,
  SliderPanel,
  FieldButtonGroup,
  DatePicker,
  FieldDropSide,
  CsplTable as Table,
  Link,
  DifferentParticipantElectionTable,
  WarningModal,
  FormControlSearch,
} from "../../../components";
import moment from "moment";
import { INVESTMENTS_BASED_ON, usDateFormat } from "../../../utils";
import { isEmpty, get, uniqBy } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { Form, Button, InputGroup, Image, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

const SameSourceElectionDifferentPartcipantElection = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    handleChange,
    handleSubmit,
    investmentList,
    setToggle,
    toggle,
    additionalAutoEnrollmentData,
    setValues,
    deleteInvestment,
    planId,
    invetmentElectionError,
  } = props;

  const errorMsg = (invsum) =>
    invsum !== 100
      ? "PL821 : The total value of investment election should not exceed or subceed 100%"
      : "";

  const [inputFields, setInputFields] = useState([{ from: "", to: "" }]);
  const [dateFields, setDateFields] = useState([{ from: "", to: "" }]);
  const [retirementFields, setRetirementFields] = useState([
    { from: "", to: "" },
  ]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [filteredResponse, setFilteredResponse] = useState({});
  const [addedInvestments, setAddedInvestments] = useState({});
  const [searchString, setSearchString] = useState("");
  const [saveInvestments, setSaveInvestments] = useState({});
  const [categoryIndex, setCategoryIndex] = useState();
  const handleInputChange = (index, event) => {
    if (event.target.name.includes("from")) {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.ageFrom`,
        event.target.value
      );
    } else {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.ageTo`,
        event.target.value
      );
    }
  };
  const [modalVisible, setModalVisible] = useState(false);
  useDeepEffect(() => {
    setSaveInvestments(values.initialSavedInvestments);
    setAddedInvestments(values.initialSavedInvestments);
  }, [values.initialSavedInvestments]);

  const handleAddAge = (from, to) => {
    handleAddFields();
  };

  const handleAddFields = () => {
    setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList", [
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList,
      {
        investmentBasedOn: 1,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ]);
  };

  const handleRemoveFields = (index) => {
    setFieldValue(
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      get(
        values,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        []
      ).filter((_, ind) => ind !== index)
    );
  };

  const handleDateAddFields = () => {
    setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList", [
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList,
      {
        investmentBasedOn: 2,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ]);
  };

  const handleDateInputChange = (index, event, action) => {
    if (action === "from") {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
        event
      );
    } else {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
        event
      );
    }
  };

  const handleDateRemoveFields = (index) => {
    setFieldValue(
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      get(
        values,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        []
      ).filter((_, ind) => ind !== index)
    );
  };

  const handleRetirementDateAddFields = () => {
    setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList", [
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList,
      {
        investmentBasedOn: 3,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ]);
  };

  const handleRetirementDateInputChange = (index, event, action) => {
    if (action === "from") {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
        event
      );
    } else {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
        event
      );
    }
  };

  const handleRetirementDateRemoveFields = (index) => {
    setFieldValue(
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      get(
        values,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        []
      ).filter((_, ind) => ind !== index)
    );
  };

  let ageCat = [];
  if (
    !isEmpty(
      get(values, "additionalAutoEnrollmentInvestmentElectionBasedOnList", [])
    )
  )
    get(
      values,
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      []
    ).map((e, i) => {
      var c = {};
      c = null;
      if (e.ageFrom && e.ageTo) {
        c = {
          label: (
            <div className="ml-2">
              {" "}
              <div>{e.ageFrom} Years </div>{" "}
              <div className="text-secondary-scss"> to</div>{" "}
              <div>{e.ageTo} Years</div>{" "}
            </div>
          ),
          className: "column-age",
          columnName: e.ageFrom + "-" + e.ageTo,
        };
        ageCat.push(c);
      }
    });

  const ageTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Age Group",
      className: "ageGroup",
      columnName: "ageGroup",
      isSubTable: true,
      subTable: [
        ...ageCat,
        {
          label: "Default",
          className: "column-Default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const birthDateCat = [];
  if (
    !isEmpty(
      get(values, "additionalAutoEnrollmentInvestmentElectionBasedOnList", [])
    )
  )
    get(
      values,
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      []
    ).map((e, i) => {
      var c = {};
      c = null;
      if (e.from && e.to) {
        c = {
          label: (
            <div className="ml-2">
              {" "}
              <div>{moment(e.from).format("MM/DD/YYYY")} </div>{" "}
              <div className="text-secondary-scss"> to</div>{" "}
              <div>{moment(e.to).format("MM/DD/YYYY")}</div>{" "}
            </div>
          ),
          className: "column-Birthdate",
          columnName: usDateFormat(e.from) + "-" + usDateFormat(e.to),
        };
        birthDateCat.push(c);
      }
    });

  const dateTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Birth Date Group",
      className: "birthDateGroup",
      columnName: "birthDateGroup",
      isSubTable: true,
      subTable: [
        ...birthDateCat,
        {
          label: "Default",
          className: "column-default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const retirementCat = [];
  if (
    !isEmpty(
      get(values, "additionalAutoEnrollmentInvestmentElectionBasedOnList", [])
    )
  )
    get(
      values,
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      []
    ).map((e, i) => {
      var c = {};
      c = null;
      if (e.from && e.to) {
        c = {
          label: (
            <div className="ml-2">
              {" "}
              <div>{moment(e.from).format("MM/DD/YYYY")} </div>{" "}
              <div className="text-secondary-scss"> to</div>{" "}
              <div>{moment(e.to).format("MM/DD/YYYY")}</div>{" "}
            </div>
          ),
          className: "column-Birthdate",
          columnName: usDateFormat(e.from) + "-" + usDateFormat(e.to),
        };
        retirementCat.push(c);
      }
    });

  const retirementTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Retirement Date Group",
      className: "retirementDateGroup",
      columnName: "retirementDateGroup",
      isSubTable: true,
      subTable: [
        ...retirementCat,
        {
          label: "Default",
          className: "column-default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const addInvestmentsToPlan = (investment) => {
    setAddedInvestments({
      ...addedInvestments,
      [categoryIndex]: [...(addedInvestments[categoryIndex] || []), investment],
    });
  };

  const onViewButtonClick = (index) => {
    setModalOpen(true);
    setCategoryIndex(index);
  };

  const onSubmit = (savedInvestments) => {
    setSaveInvestments({
      ...saveInvestments,
      [categoryIndex]: savedInvestments,
    });
    setModalOpen(false);
  };

  const onCancel = () => {
    if (
      addedInvestments[categoryIndex]?.length !=
      saveInvestments[categoryIndex]?.length
    ) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };
  const modalOnCancel = () => {
    setAddedInvestments({
      ...addedInvestments,
      [categoryIndex]: saveInvestments[categoryIndex],
    });
    setModalOpen(false);
    setModalVisible(false);
  };
  useDeepEffect(() => {
    setFilteredResponse({
      ...filteredResponse,
      [categoryIndex]: investmentList.filter((team) => {
        return get(team, "name", "")
          .toLowerCase()
          .includes(searchString.toLowerCase());
      }),
    });
  }, [searchString, investmentList, categoryIndex]);

  const deletefunction = (name, index, sourceInd, cellIndex, ind) => {
    // var temp = totalInvestments.filter((e) => e.name !== name);
    var temp = saveInvestments[index].filter((e) => e.name !== name);
    // setTotalInvestments(temp);
    setAddedInvestments({ ...addedInvestments, [index]: temp });
    setSaveInvestments({ ...saveInvestments, [index]: temp });
    // values.additionalAutoEnrollmentCategorywiseInvestment[
    //   cellIndex - 1
    // ] = values.additionalAutoEnrollmentCategorywiseInvestment[cellIndex - 1].filter(
    //   (x) => x.name !== name
    // );
    setValues({
      ...values,
      additionalAutoEnrollmentCategorywiseInvestment: values.additionalAutoEnrollmentCategorywiseInvestment.map(
        (y) => y.filter((x) => x.name !== name)
      ),
    });
  };

  const onDeleteClick = (name, index, sourceInd, cellIndex, ind) => {
    setToggle(!toggle);
    // autoEnrollment.investmentDetails
    //   ? autoEnrollment.investmentDetails.forEach((e) =>
    //       e.name === name
    //         ? deleteInvestment(planId, e.investmentId).then((response) => {
    //             if (response) deletefunction(name);
    //           })
    //         : deletefunction(name)
    //     )
    //   : deletefunction(name);
    deletefunction(name, index, sourceInd, cellIndex, ind);
  };
  const investmentListLength = (filteredResponse[categoryIndex] || []).length;
  const sliderPanel = (
    <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
      <div className="d-flex justify-content-between align-baseline">
        <div>
          <p className="plan-heading-plan">Plan Investments</p>
          <p className="enrollment-sub-heading">
            {investmentListLength === 1
              ? "Investment Available"
              : "Investments Available"}
          </p>
        </div>
        <div>
          <Button variant="secondary" onClick={() => onCancel()}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => onSubmit(addedInvestments[categoryIndex])}
            className="ml-4"
          >
            Save
          </Button>
        </div>
      </div>
      <div className="search-bar-investment">
        <Form>
          <InputGroup>
            <FormControlSearch
              size="lg"
              id="plan-search-box"
              className="plan-search-box"
              type="search"
              autoComplete="off"
              placeholder="Search Investment"
              onChange={(e) => setSearchString(e.target.value)}
            />
            {/* <InputGroup.Append>
              <InputGroup.Text className="search-bar-button">
                <Image src="/assets/icons/svg/search.svg" width="14px" />
              </InputGroup.Text>
            </InputGroup.Append> */}
          </InputGroup>
        </Form>
      </div>
      <p className="enrollment-side-content">
        {investmentListLength}{" "}
        {investmentListLength === 1
          ? "Investment Available"
          : "Investments Available"}
      </p>
      <div className="scroll-body">
        {filteredResponse[categoryIndex] &&
          (filteredResponse[categoryIndex] || []).map((e, i) => (
            <div className="d-flex justify-content-between">
              <p>{e.name}</p>
              {(addedInvestments[categoryIndex] || []).find(
                (y) => y.name === e.name
              ) ? (
                <Button
                  size="sm"
                  style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                  variant="secondary"
                  disabled
                  classname="custom-added"
                >
                  Added
                </Button>
              ) : (
                <>
                  <Button
                    style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                    variant="secondary"
                    onClick={() => addInvestmentsToPlan(e)}
                  >
                    Add
                  </Button>
                </>
              )}
            </div>
          ))}
      </div>
    </SliderPanel>
  );

  const addInvestments = (index) => (
    <div>
      <div className="mt-40">
        <AddPlans
          content="No Investments added."
          buttonLabel="Add Investment"
          disabled={isEdit && !isSave}
          onPrimaryClick={() => onViewButtonClick(index)}
        />
        <p
          style={{
            display: "block",
            color: "#ff5050",
            fontSize: "0.75rem",
            marginTop: "0rem",
          }}
        >
          {get(
            invetmentElectionError,
            "investmentElectionSameSourceDiffParticipant",
            ""
          )}
        </p>
      </div>
      {sliderPanel}
    </div>
  );
  const Invsum = (index, actualCellIndex) => {
    let sum1 = 0;
    if (
      !isEmpty(values.additionalAutoEnrollmentCategorywiseInvestment) &&
      !isEmpty(
        values.additionalAutoEnrollmentCategorywiseInvestment[actualCellIndex]
      )
    )
      values.additionalAutoEnrollmentCategorywiseInvestment[
        actualCellIndex
      ].map((x) => {
        const tempInv = x?.investmentPercentage ? x?.investmentPercentage : 0;
        return (sum1 = sum1 + tempInv);
      });
    return sum1;
  };
  const AddName = (
    e,
    investmentName,
    investmentId,
    index,
    ind,
    sName,
    category
  ) => {
    if (
      !isEmpty(values.additionalAutoEnrollmentCategorywiseInvestment) &&
      !isEmpty(values.additionalAutoEnrollmentCategorywiseInvestment[index]) &&
      !isEmpty(
        values.additionalAutoEnrollmentCategorywiseInvestment[index][ind]
      )
    ) {
      //if(!isEmpty(values.autoEnrollmentSouceInvestmentElections[index].investmentElection[ind])){
      values.additionalAutoEnrollmentCategorywiseInvestment[index][
        ind
      ].investmentName = investmentName;
      values.additionalAutoEnrollmentCategorywiseInvestment[index][
        ind
      ].investmentId = investmentId;
      const x = sName.split("-");
      if (category === 1 && sName !== "Default") {
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].ageFrom = x[0];
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].ageTo = x[1];
      } else if (category === 2 && sName !== "Default") {
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].birthDateFrom = x[0];
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].birthDateTo = x[1];
      } else if (category === 3 && sName !== "Default") {
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].retirementDateFrom = x[0];
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].retirementDateTo = x[1];
      }
      if (sName === "Default")
        values.additionalAutoEnrollmentCategorywiseInvestment[index][
          ind
        ].isDefaultCategory = true;
      // }
    }
    handleChange(e);
  };

  const investmentElectionLength = get(
    values,
    "additionalAutoEnrollmentInvestmentElectionBasedOnList",
    []
  ).length;

  const filteredInvestmentElectionLength = get(
    values,
    "additionalAutoEnrollmentInvestmentElectionBasedOnList",
    []
  ).filter((_) => _.isDefaultCategory).length;

  return (
    <div>
      <Field
        size="md"
        isRequired
        name={fields.investmentBasedOn}
        label={"Investment based on "}
        options={INVESTMENTS_BASED_ON}
        value={values[fields.investmentBasedOn]}
        selectedValue={values[fields.investmentBasedOn]}
        onChange={(value) => {
          // values.additionalAutoEnrollmentCategorywiseInvestment = [[]];
          // values[fields.investmentBasedOn] = value;
          // setFieldValue(fields.investmentBasedOn, value);
          setValues({
            ...values,
            [fields.investmentBasedOn]: value,
            additionalAutoEnrollmentCategorywiseInvestment: [[{}]],
            additionalAutoEnrollmentInvestmentElectionBasedOnList: [
              {
                investmentBasedOn: value,
                ageFrom: null,
                ageTo: null,
                from: null,
                to: null,
              },
            ],
          });
        }}
        component={FieldButtonGroup}
        //validate={required}
        disabled={isEdit && !isSave}
        validate={(value) => {
          return [undefined, null, ""].includes(value) ? "Required" : undefined;
        }}
      />

      {values[fields.investmentBasedOn] === 1 ? (
        <div>
          <h5>Age</h5>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              {get(
                values,
                "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                []
              )
                // .filter((_) => !_.isDefaultCategory)
                .map((inputField, index) => {
                  const fieldName = `investmentBasedOn[index].fromAge`;
                  if (inputField.isDefaultCategory) return <></>;
                  return (
                    <Row
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <Fragment key={`${inputField}~${index}`}>
                        <Field
                          size="xs"
                          isRequired
                          label="From"
                          name={`age.${index}.from`}
                          placeholder="Enter age"
                          component={FieldInputNumber}
                          type="number"
                          value={inputField.ageFrom}
                          onChange={(event) => handleInputChange(index, event)}
                          disabled={isEdit && !isSave}
                          autoComplete="off"
                          max={99}
                          validate={(value) => {
                            return [undefined, null, ""].includes(
                              inputField.ageFrom
                            )
                              ? "PL825 : Required"
                              : parseInt(inputField.ageFrom) < 18
                              ? "PL826 : Age should be greater than 18"
                              : undefined;
                          }}
                        />
                        &nbsp;&nbsp;&nbsp;
                        <div
                          style={{
                            marginLeft: "2rem",
                          }}
                        ></div>
                        <Field
                          size="xs"
                          isRequired
                          label="To"
                          name={`age.${index}.to`}
                          placeholder="Enter age"
                          component={FieldInputNumber}
                          type="number"
                          value={inputField.ageTo}
                          onChange={(event) => handleInputChange(index, event)}
                          disabled={isEdit && !isSave}
                          autoComplete="off"
                          max={99}
                          validate={(value) => {
                            return [undefined, null, ""].includes(
                              inputField.ageTo
                            )
                              ? "PL828 : Required"
                              : inputField.ageTo < inputField.ageFrom
                              ? "PL827 : From age cannot be greater than To age"
                              : undefined;
                          }}
                        />
                        <div className="form-group col-sm-2 investment-basedon-icons">
                          {investmentElectionLength - 1 === index && (
                            <button
                              className="btn btn-link"
                              type="button"
                              onClick={() => handleAddFields()}
                              disabled={isEdit && !isSave}
                            >
                              +
                            </button>
                          )}
                          {((filteredInvestmentElectionLength === 0 &&
                            index !== 0) ||
                            (filteredInvestmentElectionLength !== 0 &&
                              index !== 1)) && (
                            <button
                              className="btn btn-link"
                              type="button"
                              onClick={() => {
                                if (!(isEdit && !isSave))
                                  handleRemoveFields(index);
                              }}
                              disabled={isEdit && !isSave}
                            >
                              <FontAwesomeIcon icon={faTrashAlt} color="red" />
                            </button>
                          )}
                          &nbsp;&nbsp;&nbsp;
                        </div>
                      </Fragment>
                    </Row>
                  );
                })}
            </div>
            <br />
          </form>

          <div>
            {!isEmpty(saveInvestments[1]) ? (
              <>
                <div>
                  <div className="d-flex justify-content-between align-baseline">
                    <p className="mt-20 plan-heading-plan">
                      List of Investment Election Added
                    </p>
                    <Button
                      variant="secondary"
                      disabled={isEdit && !isSave}
                      onClick={() => {
                        setModalOpen(true);
                        setCategoryIndex(1);
                      }}
                    >
                      Add Investment
                    </Button>
                  </div>
                  <div>
                    {/* <Table className="different-participants-election-table">
                      <Table.Thead>
                        <Table.Tr>
                          {ageTable.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {saveInvestments[1].map((investment, index) => {
                          return (
                            <Table.Tr key={index}>
                              {ageTable.map((item, cellIndex) => {
                                const fieldName = `additionalAutoEnrollmentCategorywiseInvestment[${
                                  cellIndex - 1
                                }][${index}].investmentPercentage`;
                                // "1" +
                                // "ID" +
                                // cellIndex +
                                // investment.name;
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return investment.name;
                                  }
                                  if (item.columnName == "Action") {
                                    return (
                                      <Link>
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          color="red"
                                          onClick={() => {
                                            if (!(isEdit && !isSave))
                                              onDeleteClick(
                                                investment.name,
                                                1,
                                                cellIndex,
                                                index
                                              );
                                          }}
                                        />
                                      </Link>
                                    );
                                  }
                                  return (
                                    <Field
                                      size="xs"
                                      isRequired
                                      name={fieldName}
                                      hasSuggestion
                                      shouldDisplaySuggestion
                                      component={FieldInputPercentage}
                                      type="number"
                                      value={get(values, fieldName)}
                                      onChange={(e) => {
                                        AddName(
                                          e,
                                          investment.name,
                                          investment.id,
                                          cellIndex - 1,
                                          index,
                                          item.label,
                                          1
                                        );
                                      }}
                                      disabled={isEdit && !isSave}
                                      autoComplete="off"
                                      validate={(value) => {
                                        return value === null ||
                                          value === undefined ||
                                          value === ""
                                          ? "PL545 : Required"
                                          : value === 0
                                          ? "PL546 : Allocation percentage cannot be 0"
                                          : undefined;
                                      }}
                                    />
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          );
                        })}
                      </Table.Tbody>
                      <div className="line-separator-total" />
                      <Table.Tbody>
                        <Table.Tr>
                          {ageTable.map((item, cellIndex) => {
                            const getContent = () => {
                              if (item.columnName == "Investment") {
                                return "Total";
                              }
                              if (item.columnName == "Action") {
                                return null;
                              }
                              return (
                                <div>
                                  <Field
                                    size="xs"
                                    isRequired
                                    name="totalBox"
                                    hasSuggestion
                                    shouldDisplaySuggestion
                                    component={FieldInputPercentage}
                                    type="number"
                                    value={Invsum(cellIndex - 1)}
                                    autoComplete="off"
                                    disabled
                                    validate={(value) => {
                                      return Invsum(cellIndex - 1) != 100
                                        ? " "
                                        : undefined;
                                    }}
                                  />
                                  <p
                                    style={{
                                      display: "block",
                                      color: "#ff5050",
                                      fontSize: "0.75rem",
                                      marginTop: "0rem",
                                    }}
                                  >
                                    {errorMsg(Invsum(cellIndex - 1))}
                                  </p>
                                </div>
                              );
                            };

                            return (
                              <Table.Td
                                key={cellIndex}
                                className={item.className}
                              >
                                {getContent()}
                              </Table.Td>
                            );
                          })}
                        </Table.Tr>
                      </Table.Tbody>
                    </Table> */}
                    <DifferentParticipantElectionTable
                      isAdditionalAutoenrollmentSameSource={true}
                      headerData={ageTable}
                      actualData={saveInvestments[1]}
                      onDeleteClick={onDeleteClick}
                      errorMsg={errorMsg}
                      Invsum={Invsum}
                      AddName={AddName}
                      values={values}
                      isEdit={isEdit}
                      isSave={isSave}
                      investmentBasedOn={1}
                    />
                  </div>
                </div>
                {sliderPanel}
              </>
            ) : (
              addInvestments(1)
            )}
          </div>
        </div>
      ) : null}

      {values[fields.investmentBasedOn] === 2 ? (
        <>
          <h5>BirthDate</h5>
          <form onSubmit={handleDateAddFields}>
            <div className="form-row">
              {get(
                values,
                "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                []
              )
                // .filter((_) => !_.isDefaultCategory)
                .map((inputField, index) => {
                  if (inputField.isDefaultCategory) return <></>;
                  return (
                    <Row
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <Fragment key={`${inputField}~${index}`}>
                        <Field
                          isRequired
                          label="From"
                          size="md"
                          name={`birthDate.${index}.from`}
                          value={usDateFormat(inputField.from)}
                          placeholder="Select Birthdate"
                          isDatePicker
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                handleDateInputChange(index, value, "from")
                              }
                              value={usDateFormat(inputField.from)}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                          validate={(value) => {
                            return [undefined, null, ""].includes(
                              inputField.from
                            )
                              ? "PL831 : Required"
                              : undefined;
                          }}
                          onClear={() =>
                            setFieldValue(
                              `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
                              null
                            )
                          }
                        />
                        <div
                          style={{
                            marginLeft: "2rem",
                          }}
                        ></div>
                        <Field
                          isRequired
                          label="To"
                          size="md"
                          name={`birthDate.${index}.to`}
                          value={usDateFormat(inputField.to)}
                          placeholder="Select Birthdate"
                          isDatePicker
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                handleDateInputChange(index, value, "To")
                              }
                              value={usDateFormat(inputField.to)}
                            />
                          }
                          component={FieldDropSide}
                          disabled={isEdit && !isSave}
                          validate={(value) => {
                            return [undefined, null, ""].includes(inputField.to)
                              ? "PL833 : Required"
                              : inputField.to < inputField.from
                              ? "PL833 : From date cannot be greater than To date"
                              : undefined;
                          }}
                          onClear={() =>
                            setFieldValue(
                              `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
                              null
                            )
                          }
                        />
                        <div className="form-group  investment-basedon-icons">
                          {investmentElectionLength - 1 === index && (
                            <button
                              className="btn btn-link"
                              type="button"
                              onClick={() => handleDateAddFields()}
                              disabled={isEdit && !isSave}
                            >
                              +
                            </button>
                          )}
                          {((filteredInvestmentElectionLength === 0 &&
                            index !== 0) ||
                            (filteredInvestmentElectionLength !== 0 &&
                              index !== 1)) && (
                            <button
                              className="btn btn-link"
                              type="button"
                              onClick={() => {
                                if (!(isEdit && !isSave))
                                  handleDateRemoveFields(index);
                              }}
                              disabled={isEdit && !isSave}
                            >
                              <FontAwesomeIcon icon={faTrashAlt} color="red" />
                            </button>
                          )}
                        </div>
                      </Fragment>
                    </Row>
                  );
                })}
            </div>
            <br />
          </form>

          <div>
            {!isEmpty(saveInvestments[2]) ? (
              <>
                <div>
                  <div className="d-flex justify-content-between align-baseline">
                    <p className="mt-20 plan-heading-plan">
                      List of Investment Election Added
                    </p>
                    <Button
                      variant="secondary"
                      disabled={isEdit && !isSave}
                      onClick={() => {
                        setModalOpen(true);
                        setCategoryIndex(2);
                      }}
                    >
                      Add Investment
                    </Button>
                  </div>
                  <div>
                    {/* <Table className="different-participants-election-table">
                      <Table.Thead>
                        <Table.Tr>
                          {dateTable.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {saveInvestments[2].map((investment, index) => {
                          return (
                            <Table.Tr key={index}>
                              {dateTable.map((item, cellIndex) => {
                                const fieldName = `additionalAutoEnrollmentCategorywiseInvestment[${cellIndex - 1
                                  }][${index}].investmentPercentage`;
                                // "2" +
                                // "ID" +
                                // cellIndex +
                                // investment.name;
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return investment.name;
                                  }
                                  if (item.columnName == "Action") {
                                    return (
                                      <Link>
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          color="red"
                                          onClick={() => {
                                            if (!(isEdit && !isSave))
                                              onDeleteClick(
                                                investment.name,
                                                2,
                                                cellIndex
                                              );
                                          }}
                                        />
                                      </Link>
                                    );
                                  }
                                  return (
                                    <Field
                                      size="xs"
                                      isRequired
                                      name={fieldName}
                                      hasSuggestion
                                      shouldDisplaySuggestion
                                      component={FieldInputPercentage}
                                      type="number"
                                      value={get(values, fieldName)}
                                      onChange={(e) => {
                                        AddName(
                                          e,
                                          investment.name,
                                          investment.id,
                                          cellIndex - 1,
                                          index,
                                          item.label,
                                          2
                                        );
                                      }}
                                      disabled={isEdit && !isSave}
                                      autoComplete="off"
                                      validate={(value) => {
                                        return value === null ||
                                          value === undefined ||
                                          value === ""
                                          ? "PL545 : Required"
                                          : value === 0
                                          ? "PL546 : Allocation percentage cannot be 0"
                                          : undefined;
                                      }}
                                    />
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          );
                        })}
                      </Table.Tbody>
                      <div className="line-separator-total" />
                      <Table.Tbody>
                        <Table.Tr>
                          {dateTable.map((item, cellIndex) => {
                            const getContent = () => {
                              if (item.columnName == "Investment") {
                                return "Total";
                              }
                              if (item.columnName == "Action") {
                                return null;
                              }
                              return (
                                <div>
                                  <Field
                                    size="xs"
                                    isRequired
                                    name="totalBox"
                                    hasSuggestion
                                    shouldDisplaySuggestion
                                    component={FieldInputPercentage}
                                    type="number"
                                    value={Invsum(cellIndex - 1)}
                                    autoComplete="off"
                                    disabled
                                    validate={(value) => {
                                      return Invsum(cellIndex - 1) != 100
                                        ? " "
                                        : undefined;
                                    }}
                                  />

                                  <p
                                    style={{
                                      display: "block",
                                      color: "#ff5050",
                                      fontSize: "0.75rem",
                                      marginTop: "0rem",
                                    }}
                                  >
                                    {errorMsg(Invsum(cellIndex - 1))}
                                  </p>
                                </div>
                              );
                            };

                            return (
                              <Table.Td
                                key={cellIndex}
                                className={item.className}
                              >
                                {getContent()}
                              </Table.Td>
                            );
                          })}
                        </Table.Tr>
                      </Table.Tbody>
                    </Table> */}
                    <DifferentParticipantElectionTable
                      isAdditionalAutoenrollmentSameSource={true}
                      headerData={dateTable}
                      actualData={saveInvestments[2]}
                      onDeleteClick={onDeleteClick}
                      errorMsg={errorMsg}
                      Invsum={Invsum}
                      AddName={AddName}
                      values={values}
                      isEdit={isEdit}
                      isSave={isSave}
                      investmentBasedOn={2}
                    />
                  </div>
                </div>
                {sliderPanel}
              </>
            ) : (
              addInvestments(2)
            )}
          </div>
        </>
      ) : null}

      {values[fields.investmentBasedOn] == 3 ? (
        <>
          <h5>RetirementDate</h5>
          <form onSubmit={handleRetirementDateAddFields}>
            <div className="form-row">
              {get(
                values,
                "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                []
              ).map((inputField, index) => {
                if (inputField.isDefaultCategory) return <></>;
                return (
                  <Row
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    <Fragment key={`${inputField}~${index}`}>
                      <Field
                        isRequired
                        label="From"
                        size="md"
                        name={`retirement.${index}.from`}
                        value={usDateFormat(inputField.from)}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              handleRetirementDateInputChange(
                                index,
                                value,
                                "from"
                              )
                            }
                            value={usDateFormat(inputField.from)}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        validate={(value) => {
                          return [undefined, null, ""].includes(inputField.from)
                            ? "PL835 : Required"
                            : undefined;
                        }}
                        onClear={() =>
                          setFieldValue(
                            `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
                            null
                          )
                        }
                      />
                      <div
                        style={{
                          marginLeft: "2rem",
                        }}
                      ></div>
                      <Field
                        isRequired
                        label="To"
                        size="md"
                        name={`retirement.${index}.to`}
                        value={usDateFormat(inputField.to)}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              handleRetirementDateInputChange(
                                index,
                                value,
                                "To"
                              )
                            }
                            value={usDateFormat(inputField.to)}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        validate={(value) => {
                          return [undefined, null, ""].includes(inputField.to)
                            ? "PL837 : Required"
                            : inputField.to < inputField.from
                            ? "PL836 : From date cannot be greater than To date"
                            : undefined;
                        }}
                        onClear={() =>
                          setFieldValue(
                            `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
                            null
                          )
                        }
                      />

                      <div className="form-group investment-basedon-icons">
                        {investmentElectionLength - 1 === index && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => handleRetirementDateAddFields()}
                            disabled={isEdit && !isSave}
                          >
                            +
                          </button>
                        )}
                        {((filteredInvestmentElectionLength === 0 &&
                          index !== 0) ||
                          (filteredInvestmentElectionLength !== 0 &&
                            index !== 1)) && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => {
                              if (!(isEdit && !isSave))
                                handleRetirementDateRemoveFields(index);
                            }}
                            disabled={isEdit && !isSave}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} color="red" />
                          </button>
                        )}
                      </div>
                    </Fragment>
                  </Row>
                );
              })}
            </div>
            <br />
          </form>

          <div>
            {!isEmpty(saveInvestments[3]) ? (
              <>
                <div>
                  <div className="d-flex justify-content-between align-baseline">
                    <p className="mt-20 plan-heading-plan">
                      List of Investment Election Added
                    </p>
                    <Button
                      variant="secondary"
                      disabled={isEdit && !isSave}
                      onClick={() => {
                        setModalOpen(true);
                        setCategoryIndex(3);
                      }}
                    >
                      Add Investment
                    </Button>
                  </div>
                  <div>
                    {/* <Table className="different-participants-election-table">
                      <Table.Thead>
                        <Table.Tr>
                          {retirementTable.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {saveInvestments[3].map((investment, index) => {
                          return (
                            <Table.Tr key={index}>
                              {retirementTable.map((item, cellIndex) => {
                                const fieldName = `additionalAutoEnrollmentCategorywiseInvestment[${
                                  cellIndex - 1
                                }][${index}].investmentPercentage`;
                                // "3" +
                                // "ID" +
                                // cellIndex +
                                // investment.name;
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return investment.name;
                                  }
                                  if (item.columnName == "Action") {
                                    return (
                                      <Link>
                                        <FontAwesomeIcon
                                          icon={faTrashAlt}
                                          color="red"
                                          onClick={() => {
                                            if (!(isEdit && !isSave))
                                              onDeleteClick(
                                                investment.name,
                                                3,
                                                cellIndex
                                              );
                                          }}
                                        />
                                      </Link>
                                    );
                                  }
                                  return (
                                    <Field
                                      size="xs"
                                      isRequired
                                      name={fieldName}
                                      hasSuggestion
                                      shouldDisplaySuggestion
                                      component={FieldInputPercentage}
                                      type="number"
                                      value={get(values, fieldName)}
                                      onChange={(e) => {
                                        AddName(
                                          e,
                                          investment.name,
                                          investment.id,
                                          cellIndex - 1,
                                          index,
                                          item.label,
                                          3
                                        );
                                      }}
                                      disabled={isEdit && !isSave}
                                      autoComplete="off"
                                      validate={(value) => {
                                        return value === null ||
                                          value === undefined ||
                                          value === ""
                                          ? "PL545 : Required"
                                          : value === 0
                                          ? "PL546 : Allocation percentage cannot be 0"
                                          : undefined;
                                      }}
                                    />
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          );
                        })}
                      </Table.Tbody>
                      <div className="line-separator-total" />
                      <Table.Tbody>
                        <Table.Tr>
                          {retirementTable.map((item, cellIndex) => {
                            const getContent = () => {
                              if (item.columnName == "Investment") {
                                return "Total";
                              }
                              if (item.columnName == "Action") {
                                return null;
                              }
                              return (
                                <div>
                                  <Field
                                    size="xs"
                                    isRequired
                                    name="totalBox"
                                    hasSuggestion
                                    shouldDisplaySuggestion
                                    component={FieldInputPercentage}
                                    type="number"
                                    value={Invsum(cellIndex - 1)}
                                    autoComplete="off"
                                    disabled
                                    validate={(value) => {
                                      return Invsum(cellIndex - 1) != 100
                                        ? " "
                                        : undefined;
                                    }}
                                  />
                                  <p
                                    style={{
                                      display: "block",
                                      color: "#ff5050",
                                      fontSize: "0.75rem",
                                      marginTop: "0rem",
                                    }}
                                  >
                                    {errorMsg(Invsum(cellIndex - 1))}
                                  </p>
                                </div>
                              );
                            };

                            return (
                              <Table.Td
                                key={cellIndex}
                                className={item.className}
                              >
                                {getContent()}
                              </Table.Td>
                            );
                          })}
                        </Table.Tr>
                      </Table.Tbody>
                    </Table> */}
                    <DifferentParticipantElectionTable
                      isAdditionalAutoenrollmentSameSource={true}
                      headerData={retirementTable}
                      actualData={saveInvestments[3]}
                      onDeleteClick={onDeleteClick}
                      errorMsg={errorMsg}
                      Invsum={Invsum}
                      AddName={AddName}
                      values={values}
                      isEdit={isEdit}
                      isSave={isSave}
                      investmentBasedOn={3}
                    />
                  </div>
                </div>
                {sliderPanel}
              </>
            ) : (
              addInvestments(3)
            )}
          </div>
        </>
      ) : null}
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default SameSourceElectionDifferentPartcipantElection;
